import { LoadingButton } from '@mui/lab'
import { Box, Stack, TextField, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { toast } from 'react-toastify'
import { useFetchcreateCompany } from 'src/services/companies/companies'
// import { toast } from 'react-toastify'
import { useCompaniesStore } from 'src/store/useCompaniesStore'

const CreateCompanieForm = () => {
  const fetchcreateCompany = useFetchcreateCompany()
  const companies = useCompaniesStore((state) => state.companies)
  const handleCompanies = useCompaniesStore((state) => state.handleCompanies)
  const { control, handleSubmit, reset } = useForm({
    defaultValues: {
      name: '',
      alias: '',
    },
  })

  const onSubmit = async (data) => {
    try {
      const { name, alias } = data

      const request = {
        name,
        alias,
        create_at: new Date(),
        updated_at: new Date(),
      }

      fetchcreateCompany.mutateAsync(request)
    } catch (error) {
      toast.error('Failed to create companie')
    }
  }

  useEffect(() => {
    ;(async () => {
      try {
        if (fetchcreateCompany.isSuccess) {
          const response = fetchcreateCompany.data
          const newCompany = {
            alias: response.alias,
            createdAt: response.created_at,
            datasets: response.datasets,
            id: response.id,
            name: response.name,
            updatedAt: response.updated_at,
          }
          handleCompanies([...companies, newCompany])
          reset({ name: '', alias: '' })
          toast.success('Companie created')
        }
      } catch (error) {
        toast.error('Failed to create user')
      }
    })()
  }, [fetchcreateCompany.isSuccess])

  return (
    <Box
      component="form"
      method="post"
      onSubmit={handleSubmit(onSubmit)}
      sx={{ overflowY: 'scroll', position: 'relative', display: 'flex', flexDirection: 'column', gap: 3 }}
    >
      <Typography component="h2" variant="h4" textAlign="center">
        Create companie
      </Typography>
      <Stack spacing={1}>
        <Controller
          name="name"
          control={control}
          rules={{
            required: 'This field is required',
          }}
          render={({ field, formState: { errors } }) => (
            <Stack>
              <TextField {...field} label="Name" error={errors.name} />
              <Typography color="error" p={0} fontSize={14} height={20}>
                {errors.name ? errors.name.message : ''}
              </Typography>
            </Stack>
          )}
        />
        <Controller name="alias" control={control} render={({ field }) => <TextField {...field} label="Alias" />} />
      </Stack>
      <Box>
        <LoadingButton fullWidth size="large" type="submit" variant="contained">
          create
        </LoadingButton>
      </Box>
    </Box>
  )
}

export default CreateCompanieForm
